module.exports = __webpack_public_path__ + "img/asim.42b6845f.webp";